import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useConfig from "hooks/useConfig";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import { FormattedMessage } from "react-intl";
import { gridSpacing } from "store/constant";
import MainCard from "ui-component/cards/MainCard";

const ChartByMonths = ({ isLoading, dataByMonths, title, unit = "" }) => {
  const theme = useTheme();
  const { navType } = useConfig();
  const { primary } = theme.palette.text;
  const darkLight = theme.palette.dark.light;
  const grey200 = theme.palette.grey[200];
  const grey500 = theme.palette.grey[500];
  const primary200 = theme.palette.primary[200];
  const primaryDark = theme.palette.primary.dark;
  const secondaryMain = theme.palette.secondary.main;
  const secondaryLight = theme.palette.secondary.light;

  if (isLoading) {
    return (
      <>
        <FormattedMessage id="general.loading" />
      </>
    );
  }

  const chartData = {
    height: 360,
    type: "bar",
    options: {
      chart: {
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
        },
      },
      xaxis: {
        type: "category",
        categories: dataByMonths ? Object.keys(dataByMonths) : [],
        labels: {
          style: {
            colors: [primary],
          },
        },
      },
      legend: {
        show: true,
        fontFamily: `'Roboto', sans-serif`,
        position: "bottom",
        offsetX: 20,
        labels: {
          useSeriesColors: false,
        },
        markers: {
          width: 16,
          height: 16,
          radius: 5,
        },
        itemMargin: {
          horizontal: 15,
          vertical: 8,
        },
      },
      fill: {
        type: "solid",
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: true,
      },
    },
    series: [
      {
        name: title,
        data: dataByMonths ? Object.values(dataByMonths) : [],
      },
    ],
    colors: [primary200, primaryDark, secondaryMain, secondaryLight],
    yaxis: {
      labels: {
        style: {
          colors: [primary],
        },
      },
    },
    grid: {
      borderColor: navType === "dark" ? darkLight + 20 : grey200,
    },
    tooltip: {
      theme: navType === "dark" ? "dark" : "light",
    },
    legend: {
      labels: {
        colors: grey500,
      },
    },
  };

  return (
    <MainCard>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <Typography variant="subtitle2">{title}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Chart {...chartData} />
        </Grid>
      </Grid>
    </MainCard>
  );
};

ChartByMonths.propTypes = {
  isLoading: PropTypes.bool,
  dataByMonths: PropTypes.object,
};

export default ChartByMonths;
